import { useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import CustomModal from '@/components/shared/CustomModal/CustomModal'

/* export type AssignToUserProps = {
    showAdd: boolean
    showHideAdd: (showAdd: boolean) => void
    selectedModelIds: string[]
    assignedToIds: string[]
    which: 'Tract' | 'Runsheet'
    runsheetId?: string
} */

export const AssignToUser = ({
    showAdd,
    showHideAdd,
    selectedModels = [],
    assignedUserId,
    which,
}) => {
    const [selectedUser, setSelectedUser] = useState(assignedUserId)
    
    const users = useWireValue(store.users)
    
    useEffect(() => {
        actions.fetchUsers()
    }, [])
    
    return (
        <CustomModal open={showAdd} modalHandler={() => showHideAdd(!showAdd)} center>
            <div className="modal-header">Assign To User</div>
            <div className="modal-body">
                <div className="bg-base-200 py-2 px-4 rounded mb-2">
                    <span className="font-bold">{which}s:</span> {selectedModels.map(m => m.name).join(', ')}
                </div>
                <ul>
                    {(users || []).map(user => (
                        <li className="flex gap-2 items-center py-2" key={user.id}>
                            <input
                                type="radio"
                                className="radio radio-primary"
                                value={user.id}
                                id={user.id}
                                name="user"
                                checked={selectedUser === user.id}
                                onChange={() => setSelectedUser(user.id)} />
                            <label htmlFor={user.id} className="cursor-pointer">
                                {`${user.firstName} ${user.lastName}`}
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="modal-footer mt-4 flex justify-between">
                <button
                    type="button"
                    className="btn btn-primary btn-outline"
                    onClick={() => {
                        showHideAdd(!showAdd)
                    }}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="mr-3 btn btn-primary"
                    onClick={async () => {
                        await actions.assignTractToUser(selectedModels.map(m => m.id), selectedUser, which)
                        await showHideAdd(!showAdd)
                    }}
                    disabled={!selectedModels.length}>
                    Assign
                </button>
            </div>
        </CustomModal>
    )
}
